module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.css
// module id = ./src/app/admin/admin.component.css
// module chunks = main